import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { apiUrl } from '@helpers/common';
import { ResponseModel } from '@app/shared/models/commons/response.model';
import { PagingResultModel } from '@app/shared/models/commons/paging-result.model';

@Injectable()
export class AlignerService {
    private readonly SERVER: string = apiUrl + '/'

    constructor(
        private http: HttpClient
    ) { }

    search(params, token): Observable<ResponseModel<PagingResultModel<any>>> {
        const headers = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${ JSON.parse(token) }`,
            }),
        }
        return this.http.post<ResponseModel<PagingResultModel<any>>>(`${this.SERVER}aligner/search`, params, headers)
    }
}



// WEBPACK FOOTER //
// ./src/app/services/aligner.service.ts